import { useState } from "react";
import { Loader2, ShieldCheck, Clock } from "lucide-react";
import api, { formatDetail } from "@/lib/api";

/** Hostname + verify control for neutral vendor-facing callback domains. */
export function CallbackDomainField({ value, setPath, verifyPath, onUpdated, testid, label, hint }) {
    const [domain, setDomain] = useState(value?.domain || "");
    const [state, setState] = useState(value || null);
    const [busy, setBusy] = useState("");
    const [err, setErr] = useState("");
    const call = async (kind) => {
        setBusy(kind); setErr("");
        try {
            const r = kind === "save" ? await api.put(setPath, { domain: domain.trim() || null }) : await api.post(verifyPath);
            const cd = r.data.callback_domain !== undefined ? r.data.callback_domain : r.data;
            setState(cd && cd.domain ? cd : null);
            onUpdated?.(r.data);
        } catch (e) { setErr(formatDetail(e?.response?.data?.detail) || e.message); }
        finally { setBusy(""); }
    };
    const verified = state?.status === "verified";
    return (
        <div className="space-y-1" data-testid={testid}>
            <div className="text-[10px] uppercase tracking-wider text-slate-400">{label}</div>
            <div className="flex gap-2">
                <input value={domain} onChange={(e) => setDomain(e.target.value)} placeholder="pay.partner-site.com"
                       data-testid={`${testid}-input`} className="input flex-1 text-sm py-1.5 font-mono" />
                <button type="button" onClick={() => call("save")} disabled={!!busy} data-testid={`${testid}-save`}
                        className="px-3 py-1.5 rounded-md border border-slate-200 text-xs font-semibold hover:bg-slate-50 disabled:opacity-50">
                    {busy === "save" ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : "Save"}
                </button>
                {state?.domain && !verified && (
                    <button type="button" onClick={() => call("verify")} disabled={!!busy} data-testid={`${testid}-verify`}
                            className="px-3 py-1.5 rounded-md bg-slate-900 text-white text-xs font-semibold hover:bg-slate-800 disabled:opacity-50">
                        {busy === "verify" ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : "Verify DNS"}
                    </button>
                )}
            </div>
            {state?.domain && (
                <div className={`flex items-start gap-1.5 text-[11px] ${verified ? "text-emerald-700" : "text-amber-700"}`} data-testid={`${testid}-status`}>
                    {verified ? <ShieldCheck className="w-3.5 h-3.5 mt-px shrink-0" /> : <Clock className="w-3.5 h-3.5 mt-px shrink-0" />}
                    <span>{verified ? `Verified — vendor URLs use https://${state.domain}` : state.reason || "Pending DNS"}</span>
                </div>
            )}
            {!state?.domain && hint && <p className="text-[11px] text-slate-500">{hint}</p>}
            {err && <div className="text-[11px] text-rose-700" data-testid={`${testid}-error`}>{err}</div>}
        </div>
    );
}
